// extracted by mini-css-extract-plugin
export default {"box":"index_box_7aGHa clearfix","pic":"index_pic_-GlrS","text":"index_text_j8Bea","detail":"index_detail_6RzoI"};